// Navigation route from API extraData
export interface NavigationRoute {
  label: string;
  uri: string;
}

// ExtraData from API response (all fields optional)
export interface MessageExtraData {
  navigationRoutes?: NavigationRoute[];
  hints?: string[];
  relatedTopics?: string[];
}

export interface ChatMessage {
  id: string;
  text: string;
  isUser: boolean;
  timestamp: Date;
  type?: 'text' | 'quick-reply' | 'article' | 'options';
  options?: ChatOption[];
  articleId?: string;
  extraData?: MessageExtraData;
}

export interface ChatOption {
  id: string;
  label: string;
  icon?: string;
  action: 'navigate' | 'search' | 'send-message';
  value?: string;
}

export interface ChatConversation {
  id: string;
  title: string;
  lastMessage: string;
  timestamp: Date;
  messages: ChatMessage[];
  unreadCount?: number;
}

// ============================================
// Help Center Types (matching HelpCenterAdminController)
// Backend uses snake_case for JSON serialization
// ============================================

// Resource/Multimedia types from backend
export type ResourceType = 'AUDIO' | 'PHOTO' | 'VIDEO' | 'PDF' | 'CSS' | 'HTML' | 'MARKDOWN';

// Resource response matching backend ResourceRS
export interface ResourceRS {
  id: string;
  url: string;
  type: ResourceType;
}

// Help article matching backend HelpArticleAdminRS (snake_case)
export interface HelpArticle {
  id: string;
  container_id?: string;      // snake_case from backend
  title: string;
  description: string;
  icon?: string;
  multimedia?: ResourceRS;    // Full resource object for content (HTML/PDF/MD)
  view_count?: number;        // snake_case from backend
}

// Help collection/container matching backend HelpContainerAdminRS (snake_case)
export interface HelpCollection {
  id: string;
  title: string;
  description: string;
  icon?: string;
  article_count: number;      // snake_case from backend
  articles: HelpArticle[];
  expanded?: boolean;         // UI state for accordion (frontend only)
}

export enum ChatView {
  HOME = 'home',
  CONVERSATION = 'conversation',
  CONVERSATIONS_LIST = 'conversations-list',
  HELP = 'help',
  ARTICLE = 'article'
}
